<template>
  <ul :class="{'menu-list':!isSubmenuList}">
    <template v-for="(item,index) in menu">
      <p class="menu-label" v-if="typeof item === 'string'" :key="index">{{ item }}</p>
      <aside-menu-item
        v-else
        @menu-click="menuClick"
        :item="item"
        :key="index"/>
    </template>
  </ul>
</template>

<script>
import AsideMenuItem from '@/components/Layout/AsideMenuItem'

export default {
  name: 'AsideMenuList',
  components: {
    AsideMenuItem
  },
  props: {
    isSubmenuList: {
      type: Boolean,
      default: false
    },
    menu: {
      type: Array,
      default: () => []
    }
  },
  methods: {
    menuClick (item) {
      this.$emit('menu-click', item)
    }
  }
}
</script>
